import React from "react";

import { Link } from "react-router-dom";

import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import Collapse from "@material-ui/core/Collapse";

import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    root: {
        width: "100%",
        maxWidth: 300,
        backgroundColor: theme.palette.background.paper,
    },
    nested1: {
        paddingLeft: theme.spacing(4),
    },
    nested2: {
        paddingLeft: theme.spacing(6),
    },
    nested3: {
        paddingLeft: theme.spacing(8),
    },
}));

export default function MenuApp({ menuUsers, menusOpened, onOpenMenu }) {
    const classes = useStyles();

    const getNivel = (nivel) => {
        switch (nivel) {
            case 1:
                return classes.nested1;
            case 2:
                return classes.nested2;
            case 3:
                return classes.nested3;
            default:
                return null;
        }
    };

    const renderSubMenu = (menu, nivel) => {
        if (!menu.items?.length) {
            return null;
        }

        return (
            <>
                <ListItem key={`${menu.id}`} button onClick={() => onOpenMenu(menu, false)} className={getNivel(nivel)}>
                    <ListItemText>{menu.label}</ListItemText>
                    {menusOpened[menu.id] ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
                <Collapse key={`collapse-${menu.id}`} in={menusOpened[menu.id]} timeout="auto" unmountOnExit>
                    <List component="div">
                        {menu.items.map((rec) => {
                            if (rec.url) {
                                return renderMenuItem(rec, nivel + 1);
                            } else {
                                return renderSubMenu(rec, nivel + 1);
                            }
                        })}
                    </List>
                </Collapse>
            </>
        );
    };

    const renderMenuItem = (menu, nivel) => {
        return (
            <ListItem key={`${menu.id}`} button className={getNivel(nivel)}>
                <ListItemText>
                    <Link to={menu.url} onClick={() => onOpenMenu(menu, true)}>
                        {menu.label}
                    </Link>
                </ListItemText>
            </ListItem>
        );
    };

    const renderMenus = (menu) => {
        if (!menu?.length) {
            return null;
        }

        return menu.map((menu) => {
            if (menu.url) {
                return renderMenuItem(menu, 0);
            } else {
                return renderSubMenu(menu, 0);
            }
        });
    };

    return (
        <List component="nav" className={classes.root} aria-labelledby="nested-list-subheader">
            {renderMenus(menuUsers)}
        </List>
    );
}
